import API_ENDPOINTS from 'src/api/apiEndpoints'
import type { IntegrationType } from 'src/core/hooks/useIntegrations'

import { registerIntegration } from '../registry'
import { isSectionsNote } from './typeguards'
import { KWSParams } from './types'
import getAllTargetContent from './utils/getAllTargetContent'

const INTEGRATION_TYPE: IntegrationType = 'kws'

const APP_NAME = 'ADO2KWS_CAVELL'
const HOSPITAL_CODE = 'ADO'

const REPORT_TYPE = 'eindverslag'

const registerKWS = () => {
	registerIntegration<KWSParams>(INTEGRATION_TYPE, {
		disableWriteback: (params) => !params?.contact_id || !params?.patient_id || !params?.token,
		getExistingNote: async (params, notes) => {
			if (!params?.contact_id) {
				return null
			}

			return notes.find((note) => note.integrationParams?.contact_id === params.contact_id) || null
		},
		onWriteback: async (_integrationId, fullNote, options) => {
			const { id, integrationParams, note } = fullNote || {}
			const { removeEmptySections = false } = options || {}

			if (!isSectionsNote(note)) {
				throw new Error('Note is not a valid Sections note')
			}

			const findings = getAllTargetContent(note, 'Bevindingen', removeEmptySections)

			const xmlData = `
			<import xmlns="http://www.leuven.uz/importBatches/xml" application="${APP_NAME}">
				<ziekenhuis>${HOSPITAL_CODE}</ziekenhuis>
				<patient>
					<id type="eadnr">${integrationParams?.patient_id}</id>
				</patient>
				<contacten>
					<contact>
						<cnr>${integrationParams?.contact_id}</cnr>
						<verslagen>
							<verslag>
								<externId>${id}</externId>
								<type>${REPORT_TYPE}</type>
								<bevindingen encoding="UTF-8" source="text">${findings}</bevindingen>
							</verslag>
						</verslagen>
					</contact>
				</contacten>
			</import>`

			// Loaded on demand so registering the integration at startup doesn't pull axios/amplify into the entry chunk.
			const { default: api } = await import('src/api')

			await api.put(API_ENDPOINTS[INTEGRATION_TYPE], xmlData, {
				headers: { 'Content-Type': 'application/xml', Authorization: `Bearer ${integrationParams?.token}` },
			})
		},
	})
}

export default registerKWS
